import { Dates } from '../../packages/dates';
import Metadata from '../../requests/apa/Metadata';
import Translator from '../../requests/apa/Translator';
import {
  getBookmark as apiGetBookmark,
  contentData as apiContentData,
  contentSerie as apiContentSerie,
  fetchFavoriteLoader
} from '../../requests/loader';
import RequestManager from '../../requests/RequestManager';
import favoriteDelTask from '../../requests/tasks/ficha/favoriteDelTask';
import favoriteTask from '../../requests/tasks/ficha/favoriteTask';
import Utils from '../../utils/Utils';
import CardHelper from '../Card/helpers';
import logger from "src/utils/logger/logger"

// RegExp a nivel de módulo — evita recrear en cada llamada
var VALID_GROUP_ID_REGEX = /^[0-9]+$/;

// Callbacks vacíos reutilizables — evita crear nuevas funciones inline
var NOOP = function() {};

export var getTalents = function(roles, handleClick) {
  if (!roles) roles = [];
  if (!handleClick) handleClick = NOOP;

  // Un solo paso: reduce roles → flat talent array con clickHandler
  var result = [];
  for (var i = 0; i < roles.length; i++) {
    var role = roles[i];
    var talentSource = role && role.talents ? role.talents : { talent: [] };
    var talentList = talentSource.talent || [];
    for (var j = 0; j < talentList.length; j++) {
      var t = talentList[j];
      var name = t.name || '';
      var surname = t.surname || '';
      t.name = name;
      t.fullname = t.fullname || '';
      t.surname = surname;
      t.groupName = role.name;
      result.push({
        id: t.id,
        group_id: t.id,
        groupName: t.groupName,
        title: name + ' ' + surname,
        clickHandler: createClickHandler(handleClick, t)
      });
    }
  }
  return result;
};

// Función factory para clickHandler — evita closures inline en cada .map()
function createClickHandler(handler, talent) {
  return function() {
    handler(talent);
  };
}

export const getExternalTalents = (roles = [], handleClick = () => {}) => {
  const talentArray = roles
    .map(role => {
      const talent = role && role.talents ? role.talents : { talent: [] };
      logger.debug(talent);
      if (talent.length > 0) {
        talent.forEach(t => {
          t.first_name = t.first_name ? t.first_name : '';
          t.last_name = t.last_name ? t.last_name : '';
          t.groupName = role.role_name;
          t.fullname = `${t.last_name}, ${t.first_name}`;
          t.name = t.first_name;
          t.surname = t.last_name;
        });
        return talent;
      } else {
        return [];
      }
    })
    .reduce((curr, next) => {
      return curr.concat(next);
    }, []);

  return talentArray.map(talent => ({
    id: talent.id,
    group_id: talent.id,
    groupName: talent.groupName,
    title: `${talent.first_name} ${talent.last_name}`,
    name: `${talent.first_name}`,
    surname: `${talent.last_name}`,
    fullname: `${talent.last_name} ${talent.first_name}`,
    cover: talent.image ? talent.image + '?impolicy=resize&vwidth=165' : null,
    clickHandler: createClickHandler(handleClick, talent)
  }));
};

export var getSeasonId = function(contentData) {
  return (
    contentData &&
    contentData.group &&
    contentData.group.common &&
    contentData.group.common.extendedcommon &&
    contentData.group.common.extendedcommon.media &&
    contentData.group.common.extendedcommon.media.serieseason &&
    contentData.group.common.extendedcommon.media.serieseason.id
  );
};

export var getFormatTypes = function(contentData) {
  if (
    contentData &&
    contentData.group &&
    contentData.group.common &&
    contentData.group.common.extendedcommon &&
    contentData.group.common.extendedcommon.format &&
    contentData.group.common.extendedcommon.format.types
  ) {
    var types = contentData.group.common.extendedcommon.format.types;
    if (Array.isArray(types)) {
      return types;
    } else if (types.indexOf(',') !== -1) {
      return types.split(',');
    }
    return [types];
  }
  return [];
};

export var isValidGroupId = function(groupId) {
  return VALID_GROUP_ID_REGEX.test(groupId);
};

export var getContentData = function(groupId) {
  return apiContentData(groupId).then(function(data) {
    return data;
  }).catch(function() {
    return null;
  });
};

export var getGroupIdToRedirect = function(seenLast) {
  return seenLast && seenLast.episode && seenLast.episode.id ? seenLast.episode.id : null;
};

export var formatDuration = function(duration) {
  if (!duration) duration = 'HH:mm:ss';
  var durationDates = new Dates(new Dates().format('YYYY-MM-DD') + ' ' + duration);
  var hours = durationDates.hour();
  return (hours !== 0 ? hours + 'h ' : '') + durationDates.minute() + 'min';
};

export var getWatchWithBtnBGColor = function(family) {
  var genericBGColor = Translator.get('generic_button_subscriptionDescription_background', '#ECAF2A');
  if (family) {
    var familyBGColor = Translator.get(family + '_button_subscriptionDescription_background', '');
    if (familyBGColor) {
      return familyBGColor;
    }
  }
  return genericBGColor;
};

export var parseRatingCode = function(ratingId) {
  if (!ratingId) {
    return '';
  }
  return Translator.get(ratingId + '_rating_description_label');
};

export var cutStringTitleVCard = function(originaltitle) {
  return Utils.cutPlayerString(originaltitle, 30);
};

export var parseContentData = function(contentData) {
  var group = (contentData && contentData.group) || {};
  var common = group.common || {};
  var groupId = common.id;
  var title = common.title || '';
  var large_description = common.large_description || '';
  var imageClean = common.image_base_horizontal || '';
  var duration = common.duration || '';
  var extendedcommon = common.extendedcommon || {};

  var vwidth = Utils.isPlaystation4() ? '900' : '1200';
  var image_clean_horizontal_shorted = imageClean + '?impolicy=resize&vwidth=' + vwidth;

  var genres = (extendedcommon.genres && extendedcommon.genres.genre) || [];
  var media = extendedcommon.media || {};
  var format = extendedcommon.format || {};
  var types = format.types || '';

  var originaltitle = media.originaltitle || '';
  var year = media.publishyear || '';
  var rating = media.rating || {};
  var ratingId = rating.id || '';
  var haspreview = media.haspreview || 'false';
  var languageOpts = (media.language && media.language.options) || {};
  var languageArray = languageOpts.option;
  var proveedor = media.proveedor || {};
  var providerName = proveedor.nombre || '';
  var serie = media.serie || {};
  var serieTitle = serie.title || '';
  var episode = media.episode || null;
  var serieseason = media.serieseason || {};
  var seasonId = serieseason.id || null;
  var islive = media.islive;

  var titleToDisplay = serieTitle || title;
  var isSerie = !!seasonId;
  if (isSerie && episode) {
    episode.name = title;
  }

  // Precargar imagen de fondo — solo si hay URL válida
  if (image_clean_horizontal_shorted && imageClean) {
    try {
      var preloadImg = new Image();
      preloadImg.src = image_clean_horizontal_shorted;
      // No mantener referencia — permitir GC después de la carga
      preloadImg = null;
    } catch (err) {
      // Silenciar error de preload
    }
  }

  // Extraer genders en un solo paso
  var genders = [];
  for (var i = 0; i < genres.length; i++) {
    if (genres[i] && genres[i].desc) {
      genders.push(genres[i].desc);
    }
  }

  return {
    types: types,
    groupId: groupId,
    title: titleToDisplay,
    episode: episode,
    subtitle: cutStringTitleVCard(originaltitle),
    genders: genders,
    year: year,
    parentalRating: parseRatingCode(ratingId),
    synopsis: large_description,
    image: image_clean_horizontal_shorted,
    languages: languageArray,
    duration: formatDuration(duration),
    hasTrailer: haspreview === 'true',
    isSerie: isSerie,
    isLive: islive === '1',
    seasonId: seasonId,
    providerName: providerName.toLowerCase() === 'amco' ? 'Claro Video' : providerName
  };
};

export var getSerieData = function(contentData) {
  try {
    var group = (contentData && contentData.group) || {};
    var common = group.common || {};
    var groupId = common.id;
    var extendedcommon = common.extendedcommon || {};
    var media = extendedcommon.media || {};
    var episode = media.episode || {};
    var season = episode.season || '';
    var number = episode.number || '';

    return apiContentSerie(groupId).then(function(contentSerie) {
      var seasons = (contentSerie && contentSerie.seasons) || [];
      var seasonsText = null;
      if (seasons.length > 0) {
        seasonsText = seasons.length === 1
          ? '1 ' + Translator.get('season', 'Temporada')
          : seasons.length + ' ' + Translator.get('season', 'Temporada') + 's';
      }
      return {
        seasonsText: seasonsText,
        serieData: {
          groupId: groupId,
          seasons: seasons,
          seasonNumber: season,
          episodeNumber: number
        }
      };
    });
  } catch (e) {
    return Promise.resolve({
      seasonsText: '',
      serieData: null
    });
  }
};

export var resolveContentTalent = function(universal_id, external, handleTalentClick) {
  if (!handleTalentClick) handleTalentClick = NOOP;
  var resolveKey = JSON.stringify({
    default: {
      enabled: true,
      provider: 'gracenote'
    }
  });
  resolveKey = Utils.getApaMetadataKey('external_metadata', resolveKey);
  var providerTalent = resolveKey.enabled === true ? resolveKey.provider : null;
  var externalTalents = null;
  var provider_id = null;
  if (resolveKey) {
    if (
      providerTalent &&
      universal_id &&
      universal_id['metadata_providers'] &&
      universal_id['metadata_providers'][providerTalent]
    ) {
      provider_id = universal_id['metadata_providers'][providerTalent]['provider_id'];
      var arrTalent = external[providerTalent] && external[providerTalent]['cast'];
      if (arrTalent) {
        externalTalents = getExternalTalents(
          external[providerTalent]['cast'],
          handleTalentClick
        );
      }
    }
  }
  return { externalrole: externalTalents, provider_id: provider_id };
};

export var checkFavoritedContent = function(groupId, user) {
  var filterList = Utils.getAPAFilterList();
  return fetchFavoriteLoader(user, filterList).then(function(favs) {
    var favoritedContent;
    if (
      favs &&
      favs.response &&
      favs.response.groups &&
      Array.isArray(favs.response.groups)
    ) {
      favoritedContent = favs.response.groups.find(function(el) { return el.id === groupId; });
    }
    return favoritedContent && typeof favoritedContent === 'object';
  }).catch(function() {
    return false;
  });
};

export var getBookmark = function(groupId, isAnonymous) {
  var defaultBookmark = { time: '00:00:00', progress: 0, image_still: '', image_frames: '' };
  if (isAnonymous) {
    return Promise.resolve(defaultBookmark);
  }
  return apiGetBookmark(groupId).then(function(bookmark) {
    var response = (bookmark && bookmark.response) || {};
    var groups = response.groups || [];
    var firstBookmark = groups[0] || {};
    var image_still = firstBookmark.image_still || '';
    var image_frames = firstBookmark.image_frames || '';
    var vistime = firstBookmark.vistime || {};
    var last = vistime.last || {};
    var time = last.time || '00:00:00';
    var progress = last.progress || 0;
    Utils.isModalHide() && Utils.setInitialFocusChangeTime('.elementopredeterminado', 0);
    return { time: time, progress: progress, image_still: image_still, image_frames: image_frames };
  }).catch(function() {
    Utils.isModalHide() && Utils.setInitialFocusChangeTime('.elementopredeterminado', 0);
    return defaultBookmark;
  });
};

export var favoriteToggleRequest = function(requestParams, isFavorite, successCallBack, failedCallBack) {
  if (!successCallBack) successCallBack = NOOP;
  if (!failedCallBack) failedCallBack = NOOP;
  var request = isFavorite ? new favoriteDelTask(requestParams) : new favoriteTask(requestParams);
  RequestManager.addRequest(request)
    .then(function(data) {
      successCallBack(data);
    })
    .catch(function(e) {
      failedCallBack(e);
    });
};

export var isAnonymousFromProps = function(props) {
  if (!props) props = {};
  var user = props.user || {};
  var isAnonymous = user.isAnonymous;
  return isAnonymous !== undefined ? isAnonymous : true;
};

export var getIgnoreSeenLastFromMatchParams = function(props) {
  if (!props) props = {};
  var match = props.match || {};
  var params = match.params || {};
  return params.ignoreSeenLast || false;
};

export var getGroupIdFromMatchParams = function(props) {
  if (!props) props = {};
  var match = props.match || {};
  var params = match.params || {};
  return params.groupId || null;
};

// Funciones de DOM query para navegación de foco entre ribbons
// Se ejecutan solo cuando se construyen los props del ribbon (no en render)
function thereIsSeason() {
  return document.querySelector('#episodesvcard_classic_link_1');
}

function thereIsTalents() {
  return document.querySelector('#vcardtalentsribbon_tooncharacter_link_1');
}

function thereIsRecommendations() {
  return document.querySelector('#vcardrecomendationribbon_classic_link_1');
}

export var mapRecommendationToSpecialRibbonProps = function(recommendations, onRecommendationClick) {
  var id = 'vcard-recomendation-ribbon';
  var title = Translator.get('vcard_ribbon_recommendations_label', 'Otras personas que vieron este contenido, también vieron:');
  var items = [];
  for (var i = 0; i < recommendations.length; i++) {
    var r = recommendations[i];
    items.push({
      id: r.id,
      title: r.title,
      group_id: r.id,
      cover: r.image_small,
      proveedor_code: r.proveedor_code,
      provider: r.proveedor_code === 'amco' ? 'default' : r.proveedor_code,
      format_types: r.format_types.split(','),
      live_enabled: r.live_enabled,
      type: r.live_enabled === '1' ? 'live' : 'vod',
      is_series: r.is_series,
      clickHandler: createClickHandlerById(onRecommendationClick, r.id)
    });
  }
  return {
    id: id,
    type: 'landscape',
    title: title,
    byUser: false,
    offset: null,
    showFooter: false,
    isCarrouselTV: false,
    url: '',
    items: items,
    index: 0,
    bottomRibbon: false,
    key: id,
    focusHandler: NOOP,
    forceUpdateGrid: NOOP,
    hasRecordings: false,
    api: '',
    handleDeleteFromRibbonRecordings: NOOP,
    idsRibbonsUpAndDown: {
      0: {
        focusUp: thereIsSeason() ? '#episodesvcard_classic_link_1' : '.elementopredeterminado',
        focusDown: thereIsTalents() ? '#vcardtalentsribbon_tooncharacter_link_1' : null
      }
    }
  };
};

function createClickHandlerById(handler, id) {
  return function() {
    handler(id);
  };
}

export var mapTalentToSpecialRibbonProps = function(talents, content_name, thereAreRecommendations, thereAreEpisodes) {
  if (!talents) talents = [];
  var id = 'vcard-talents-ribbon';
  var title = Translator.get('vcard_ribbon_talents_label', 'Talentos');
  // Mapear items sin mutar los objetos originales
  var items = [];
  for (var i = 0; i < talents.length; i++) {
    var t = talents[i];
    items.push({
      id: t.id,
      group_id: t.group_id,
      groupName: t.groupName,
      title: t.title,
      name: t.name,
      surname: t.surname,
      fullname: t.fullname,
      cover: t.cover || CardHelper.getPlaceholder(t.groupName && t.groupName.toLowerCase()),
      clickHandler: t.clickHandler,
      typeRender: 'a',
      text_highlight: t.title,
      content_name: content_name
    });
  }
  return {
    id: id,
    type: 'tooncharacter',
    title: title,
    byUser: false,
    offset: null,
    showFooter: false,
    isCarrouselTV: false,
    url: '',
    items: items,
    index: 0,
    bottomRibbon: false,
    key: id,
    focusHandler: NOOP,
    forceUpdateGrid: NOOP,
    hasRecordings: false,
    api: '',
    handleDeleteFromRibbonRecordings: NOOP,
    idsRibbonsUpAndDown: {
      0: {
        focusUp: thereAreRecommendations
          ? '#vcardrecomendationribbon_classic_link_1'
          : thereAreEpisodes ? '#episodesvcard_classic_link_1'
            : '.elementopredeterminado',
        focusDown: null
      }
    }
  };
};

export var mapEpisodeExtraInfo = function(opts) {
  var item = (opts && opts.item) || null;
  if (!item) {
    return null;
  }
  var data = item.data || {};
  var title_episode = data.title_episode || '';
  var episode_number = data.episode_number || '';
  var description = data.description || '';
  if (!title_episode || !episode_number || !description) {
    return null;
  }
  return {
    title_episode: title_episode,
    episode_number: episode_number,
    description: description
  };
};



// WEBPACK FOOTER //
// ./src/components/Ficha/fichaHelper.js